import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const ROUTE_LOADER_STATE_KEY = '__appRouteLoader';

export const withRouteLoaderState = (state = {}, message = 'Please wait...') => ({
    ...(state || {}),
    [ROUTE_LOADER_STATE_KEY]: {
        message: String(message || '').trim() || 'Please wait...'
    }
});

const getRouteLoaderState = (location) => location?.state?.[ROUTE_LOADER_STATE_KEY] || null;

export const useRouteEntryLoader = (fallbackMessage = 'Please wait...') => {
    const location = useLocation();
    const routeLoaderState = getRouteLoaderState(location);
    const [entryLoaderMessage, setEntryLoaderMessage] = useState(() => (
        routeLoaderState ? (routeLoaderState.message || fallbackMessage) : ''
    ));

    useEffect(() => {
        if (!routeLoaderState) {
            setEntryLoaderMessage('');
            return undefined;
        }

        setEntryLoaderMessage(routeLoaderState.message || fallbackMessage);
        let firstFrame = 0;
        let secondFrame = 0;
        firstFrame = window.requestAnimationFrame(() => {
            secondFrame = window.requestAnimationFrame(() => {
                setEntryLoaderMessage('');
            });
        });

        return () => {
            window.cancelAnimationFrame(firstFrame);
            window.cancelAnimationFrame(secondFrame);
        };
    }, [fallbackMessage, routeLoaderState]);

    return entryLoaderMessage;
};

export const FullPageLoader = ({ message = 'Please wait...' }) => (
    <div className="app-page-loader-overlay" aria-live="polite" aria-busy="true">
        <div className="app-page-loader-card">
            <div className="app-page-loader-orbit" aria-hidden="true">
                <span className="app-page-loader-core"></span>
                <span className="app-page-loader-dot app-page-loader-dot--one"></span>
                <span className="app-page-loader-dot app-page-loader-dot--two"></span>
                <span className="app-page-loader-dot app-page-loader-dot--three"></span>
            </div>
            <div className="app-page-loader-progress" aria-hidden="true">
                <span></span>
            </div>
            <p>{message}</p>
        </div>
    </div>
);
